import {find, isEmpty, map} from 'lodash';
import {useCallback, useMemo} from 'react';
import {matchPath} from 'react-router';
import {useHistory, useLocation} from 'react-router-dom';

import {Select} from 'components';
import {Option} from 'interfaces';

import {MenuItemInfo} from '../types';

type Props = {
    menuItems: MenuItemInfo[];
}

export const SubMenuItemsDropdown: React.FC<Props> = ({menuItems}: Props) => {
    const {pathname} = useLocation();
    const history = useHistory();

    const topLevelMenuItem = useMemo(() => find(menuItems, (item) =>
        matchPath(pathname, {path: item.link})
    ) as MenuItemInfo, [pathname, menuItems]);

    const options: Option[] = useMemo(() => map(topLevelMenuItem?.subItems, (item) => ({
        id: item.link,
        name: item.title,
        hide: item.hidden || item.activeOnly,
    })), [topLevelMenuItem]);

    const selectedOption = useMemo(() => find(options, (option) => {
        const selectedSubItem = find(
            topLevelMenuItem?.subItems,
            (item) => matchPath(pathname, {path: item.link, exact: true})
        ) as MenuItemInfo;
        return selectedSubItem && matchPath(option.id, {path: selectedSubItem.link, exact: true});
    }), [topLevelMenuItem, options, pathname]);

    const onChange = useCallback(({id: url}) => {
        history.push(url);
    }, [history]);

    if (topLevelMenuItem && isEmpty(topLevelMenuItem?.subItems)) {
        return (
            <div className='tw-ts-h2-bold lg:tw-hidden tw-text-nowrap tw-mr-2'>
                {topLevelMenuItem.headerTitle || topLevelMenuItem.title}
            </div>
        );
    }

    return (selectedOption ?
        <div className='lg:tw-hidden tw-max-w-60 tw-flex-1 tw-mr-6'>
            <Select
                className='tw-ts-h5-bold'
                hidePlaceholder
                fill='transparent'
                value={selectedOption}
                options={options}
                filterOption={({data}) => !data.hide}
                onChange={onChange}
            />
        </div> : null);
};